import { BsCheck2Square, BsSquare } from "react-icons/bs";

import TourFormat from "./Format";

import zarinPal from "../assets/image/زرین+پال.png";
import { convertDate } from "utilities/helperFunction";

export function TourInfo({ info }) {
  const { title, type, startDate, startTime, startPlace } = info;
  return (
    <>
      <TourFormat title={"اطلاعات تور"}>
        <div className="the-tour-info">
          {title != "" ? (
            <div>
              <b> نام تور : </b>
              {title}
            </div>
          ) : (
            ""
          )}
          {type != "" ? (
            <div>
              <b> نوع تور : </b>
              {type}
            </div>
          ) : (
            ""
          )}
          {startDate != "" ? (
            <div>
              <b> تاریخ حرکت : </b>
              {convertDate(startDate)}
            </div>
          ) : (
            ""
          )}
          {startTime != "" ? (
            <div>
              <b> ساعت حرکت : </b>
              {startTime}
            </div>
          ) : (
            ""
          )}
          {startPlace != "" ? (
            <div>
              <b> محل حرکت : </b>
              {startPlace}
            </div>
          ) : (
            ""
          )}
        </div>
      </TourFormat>
    </>
  );
}

export function Attention({ rules, changeRules }) {
  return (
    <TourFormat title={"توجه"}>
      <div className="the-attention">
        {/* <div className="the-item div1">
          خریدار محترم تا زمانی که بدهی ارزی تسویه نگردد خرید شما قطعی نمی باشد.
        </div> */}
        <div className="the-item div2" onClick={() => changeRules(!rules)}>
          <span style={{ cursor: "pointer" }}>
            {rules ? <BsCheck2Square /> : <BsSquare />}
            &nbsp; &nbsp; &nbsp; &nbsp; کلیه <a href="#">قوانین عمومی</a> و
            <a href="#">قوانین کنسلی</a> را خوانده‌ام و کاملا قبول دارم.
          </span>
        </div>
        <hr className="the-line" />
      </div>
    </TourFormat>
  );
}

export function PaymentGateway({
  type,
  changeType,
  wallet,
  totalPrice,
  payPrice,
  changeSelectedGateway,
}) {
  return (
    <>
      <div className="dargahDiv mb-5">
        {wallet !== false ? (
          <>
            <p>لطفا شیوه پرداخت را انتخاب نمایید.</p>
            <div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  value={"wallet"}
                  checked={type === "wallet"}
                  onChange={() => changeType("wallet")}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault1">
                  کیف پول
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  value={"online"}
                  checked={type === "online"}
                  onChange={() => changeType("online")}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault2">
                  آنلاین
                </label>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        <div className="mt-4 mb-2">
          {type == "wallet" ? (
            <>
              <p> موجودی حساب شما :‌ {wallet} تومان</p>
              <p> مجموع پرداختی: {totalPrice} تومان</p>
              {payPrice > 0 ? (
                <p>مبلغ قابل پرداخت با کسر مبلغ کیف پول: {payPrice} تومان</p>
              ) : (
                ""
              )}
            </>
          ) : (
            <p> مجموع پرداختی: {payPrice} تومان</p>
          )}
        </div>
        {type == "online" || payPrice > 0 ? (
          <div className="mt-3">
            <p>درگاه پرداخت را انتخاب نمایید.</p>
            <div className="dargahDiv2">
              <div className="d-flex dargah">
                <label className="mx-2">
                  <input
                    type="radio"
                    name="dargah"
                    value="zarinpal"
                    checked
                    onChange={(e) => {
                      if (e.target.checked) {
                        changeSelectedGateway(e.target.value);
                      }
                    }}
                  />
                  <img src={zarinPal} alt="زرین پال" />
                </label>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
